export function toNumber(value: unknown): number {
  if (value == null || value === '') return 0;
  return Number(value);
}

export function toOptionalNumber(value: unknown): number | undefined {
  if (value == null || value === '') return undefined;
  return Number(value);
}

export function toNumberOrNull(value: unknown): number | null {
  if (value == null || value === '') return null;
  return Number(value);
}

export function toNumberRecord(
  record: Record<string, unknown>
): Record<string, number> {
  const result: Record<string, number> = {};
  for (const [key, value] of Object.entries(record)) {
    result[key] = toNumber(value);
  }
  return result;
}

/** A money amount as whole cents, so sums compare without float dust. */
function inCents(amount: number): number {
  return Math.round(amount * 100);
}

/** A money amount rounded to whole cents. */
export function roundToTheCent(amount: number): number {
  return inCents(amount) / 100;
}

/** Whether two money amounts are the same to the cent. */
export function sameToTheCent(left: number, right: number): boolean {
  return inCents(left) === inCents(right);
}

/**
 * Whether `amount` falls at least a cent short of `target`. Summing shares
 * in doubles lands an ulp under the total, so a plain `<` reports a
 * phantom shortfall.
 */
export function shortOfToTheCent(amount: number, target: number): boolean {
  return inCents(amount) < inCents(target);
}
